import React from "react";
import cx from "classnames";
import { Link } from 'react-scroll'
import {Space} from "antd";
import {ArrowDownOutlined, ArrowRightOutlined} from "@ant-design/icons";
import MobileComponentWrapper from "@/components/MobileComponentWrapper";
import styles from "@/page-components/detail/Plan/styles.module.less";
import PcComponentWrapper from "@/components/PcComponentWrapper";

const FcrpdPlan:React.FC = () => {
  return (
    <div className={styles.exam_plan_body}>
      <Link to="anchor1" duration={500}>
        <div className={styles.fcrpd_wrapper}>
          <Space className={styles.title_row}>
            <div className={cx(styles.subtitle,styles.subtitle_wrapper)}>通过考试</div>
            <div className={cx(styles.subtitle_right,styles.subtitle_wrapper)}>要求4门考试总分{'>='}240</div>
          </Space>
          <div className={styles.fcrpd}>
            <div className={styles.exam_fcrpd_item_wrapper}>
              <Space className={styles.exam_item} size={16}>
                <img src="/img/detail/exam_plan1.png" className={styles.exam_item_icon} alt="" />
                <div>
                  <p className={styles.exam_item_title}>FineReport报表开发模块</p>
                  <Space className={styles.exam_item_row} size={6}>
                    <span className={styles.exam_item_price}>￥99</span>
                    <span>满分100分 60分通过</span>
                  </Space>
                </div>
              </Space>
            </div>
            <div className={styles.exam_fcrpd_item_wrapper}>
              <Space className={styles.exam_item} size={16}>
                <img src="/img/detail/exam_plan1.png" className={styles.exam_item_icon} alt="" />
                <div>
                  <p className={styles.exam_item_title}>SQL编程语言模块</p>
                  <Space className={styles.exam_item_row} size={6}>
                    <span className={styles.exam_item_price}>￥100</span>
                    <span>满分100分 60分通过</span>
                  </Space>
                </div>
              </Space>
            </div>
            <div className={styles.exam_fcrpd_item_wrapper}>
              <Space className={styles.exam_item} size={16}>
                <img src="/img/detail/exam_plan1.png" className={styles.exam_item_icon} alt="" />
                <div>
                  <p className={styles.exam_item_title}>服务器部署模块</p>
                  <Space className={styles.exam_item_row} size={6}>
                    <span className={styles.exam_item_price}>￥100</span>
                    <span>满分100分 60分通过</span>
                  </Space>
                </div>
              </Space>
            </div>
            <div className={styles.exam_fcrpd_item_wrapper}>
              <Space className={styles.exam_item} size={16}>
                <img src="/img/detail/exam_plan1.png" className={styles.exam_item_icon} alt="" />
                <div>
                  <p className={styles.exam_item_title}>kettle数据处理模块</p>
                  <Space className={styles.exam_item_row} size={6}>
                    <span className={styles.exam_item_price}>￥100</span>
                    <span>满分100分 不限最低分</span>
                  </Space>
                </div>
              </Space>
            </div>
          </div>
        </div>
      </Link>
      <MobileComponentWrapper>
        <ArrowDownOutlined className={styles.arrow_icon}/>
      </MobileComponentWrapper>
      <PcComponentWrapper>
        <ArrowRightOutlined className={styles.arrow_icon}/>
      </PcComponentWrapper>
      <a target="_blank" href="/verify" className={styles.exam_item_wrapper}>
        <p className={cx(styles.subtitle,styles.subtitle_wrapper)}>获得证书</p>
        <Space className={styles.exam_item} size={16}>
          <img src="/img/detail/exam_plan2.png" className={styles.exam_item_icon} alt="" />
          <div>
            <p className={styles.exam_item_title} style={{fontSize: 15}}>FCP-报表交付工程师</p>
            <Space className={styles.exam_item_row} size={10}>
              <span className={styles.exam_item_price}>资深认证</span>
            </Space>
          </div>
        </Space>
      </a>
    </div>
  )
}
export default FcrpdPlan;
